import React, { useState, useEffect } from "react";

const initialState = {
    name: "",
    mobile: "",
    message: "",
};

export default function AppointmentSection() {
    const [form, setForm] = useState(initialState);
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedSlot, setSelectedSlot] = useState("");
    const [selectedType, setSelectedType] = useState(""); // NEW
    const [bookedSlots, setBookedSlots] = useState([]);
    const [loading, setLoading] = useState(false);
    const [alertBox, setAlertBox] = useState({
        show: false,
        type: "",
        message: "",
    });

    // SLOT GROUPS
    const newConsultationSlots = [
        "10:00 AM",
        "11:00 AM",
        "12:00 PM",
        "01:00 PM",
    ];

    const followUpSlots = [
        "04:00 PM",
        "04:30 PM",
        "05:00 PM",
        "05:30 PM",
        "06:00 PM",
        "06:30 PM",
        "07:00 PM",
        "07:30 PM",
        "08:00 PM",
    ];

    const slots =
        selectedType === "new"
            ? newConsultationSlots
            : selectedType === "followup"
                ? followUpSlots
                : [];

    // Handle Input
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const clearState = () => {
        setForm(initialState);
        setSelectedDate("");
        setSelectedSlot("");
        setSelectedType("");
    };

    // Submit
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.name || !form.mobile || !selectedDate || !selectedSlot || !selectedType) {
            setAlertBox({
                show: true,
                type: "error",
                message: "Please fill all required fields.",
            });
            return;
        }

        setLoading(true);

        try {
            //const response = await fetch("https://rrbrostech.com/mailathena/index.php", {
            const response = await fetch("https://aeternahomeohealth.in/mailathena/index.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    ...form,
                    type: selectedType, // NEW FIELD
                    date: selectedDate,
                    slot: selectedSlot,
                }),
            });

            const result = await response.json();

            setAlertBox({
                show: true,
                type: result.status === "success" ? "success" : "error",
                message: result.message,
            });

            if (result.status === "success") {
                setBookedSlots((prev) => [
                    ...prev,
                    { date: selectedDate, slot: selectedSlot }
                ]);

                clearState();
            }
        } catch (error) {
            setAlertBox({
                show: true,
                type: "error",
                message: "Failed to send appointment. Try again later.",
            });
        } finally {
            setLoading(false);
            setTimeout(() => {
                setAlertBox({ show: false, type: "", message: "" });
            }, 3000);
        }
    };

    useEffect(() => {
        const fetchBookedSlots = async () => {
            try {
                const response = await fetch(
                    "https://aeternahomeohealth.in/mailathena/getbookings.php"
                );
                const data = await response.json();
                setBookedSlots(data);
            } catch (error) {
                console.error("Error fetching bookings:", error);
            }
        };

        fetchBookedSlots();
    }, []);

    return (
        <section id="appointment">
            <div className="appointment-wrapper">
                {/* Loader */}
                {loading && (
                    <div className="loader-overlay">
                        <div className="spinner"></div>
                    </div>
                )}

                {/* Alert */}
                {alertBox.show && (
                    <div className="custom-alert-overlay">
                        <div className={`custom-alert ${alertBox.type}`}>
                            <h3>{alertBox.type === "success" ? "Success" : "Error"}</h3>
                            <p>{alertBox.message}</p>
                            <button
                                onClick={() =>
                                    setAlertBox({ show: false, type: "", message: "" })
                                }
                            >
                                Okay
                            </button>
                        </div>
                    </div>
                )}

                {/* LEFT SIDE */}
                <div className="opening-hours">
                    <div className="opening-header">
                        <h2>OPENING HOURS</h2>
                    </div>

                    <div className="hours-list">
                        {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map(
                            (day, index) => (
                                <div className="hour-row" key={index}>
                                    <span>{day}</span>
                                    <span>10:00 - 21:00</span>
                                </div>
                            )
                        )}
                    </div>
                </div>

                {/* RIGHT SIDE */}

                <div className="book-appointment">
                    <h2 className="title">BOOK APPOINTMENT</h2>

                    <form onSubmit={handleSubmit}>
                        <div className="form-grid">
                            <input
                                type="text"
                                name="name"
                                placeholder="Your Name"
                                value={form.name}
                                onChange={handleChange}
                            />

                            <input
                                type="tel"
                                name="mobile"
                                placeholder="Phone Number"
                                value={form.mobile}
                                onChange={handleChange}
                            />

                            <input
                                type="date"
                                value={selectedDate}
                                min={new Date().toISOString().split("T")[0]}
                                max={new Date(
                                    new Date().setMonth(new Date().getMonth() + 3)
                                ).toISOString().split("T")[0]}
                                onChange={(e) => {
                                    setSelectedDate(e.target.value);
                                    setSelectedSlot("");
                                }}
                            />

                            <textarea
                                name="message"
                                placeholder="Note"
                                rows="4"
                                value={form.message}
                                onChange={handleChange}
                            />
                        </div>

                        {/* TYPE SELECTION */}
                        <div className="type-selection">
                            <button
                                type="button"
                                className={selectedType === "new" ? "chip active" : "chip"}
                                onClick={() => {
                                    setSelectedType("new");
                                    setSelectedSlot("");
                                }}
                            >
                                New Consultation
                            </button>

                            <button
                                type="button"
                                className={selectedType === "followup" ? "chip active" : "chip"}
                                onClick={() => {
                                    setSelectedType("followup");
                                    setSelectedSlot("");
                                }}
                            >
                                Follow-up / Review
                            </button>
                        </div>

                        {/* SLOTS */}
                        {selectedDate && selectedType && (
                            <div className="slots-section">
                                <h4>Select Time Slot</h4>
                                <div className="slots">
                                    {slots.map((slot, index) => {
                                        const isBooked = bookedSlots.some(
                                            (booking) =>
                                                booking.date === selectedDate &&
                                                booking.slot === slot
                                        );

                                        return (
                                            <button
                                                type="button"
                                                key={index}
                                                disabled={isBooked}
                                                className={
                                                    isBooked
                                                        ? "slot disabled"
                                                        : selectedSlot === slot
                                                            ? "slot active"
                                                            : "slot"
                                                }
                                                onClick={() => !isBooked && setSelectedSlot(slot)}
                                            >
                                                {slot}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        <button type="submit" className="send-btn" disabled={loading}>
                            {loading ? "Sending..." : "SEND"}
                        </button>
                    </form>
                </div>

                
            </div >
        </section>
    );
}